<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col d-flex justify-content-between align-items-center">
        <div>
          <h5 class="modal-title">
            <i class="fab fa-airbnb"></i> &nbsp;<ng-container i18n>Guest Review</ng-container>
          </h5>
        </div>
        <div>
          <button (click)="dialogRef.close()" type="button" class="btn btn-outline-primary mr-3">
            <i class="far fa-times"></i> <ng-container i18n>cancel</ng-container>
          </button>
          <button
            (click)="onSave(form)"
            type="button"
            [disabled]="isLoading || !isRespondable"
            class="btn btn-secondary-info create-btn"
          >
            <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
          </button>
        </div>
      </div>
      <a (click)="dialogRef.close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <form [formGroup]="form">
        <div class="row">
          <div class="col-sm-12"><app-rating [rating]="data.review.overall_rating"></app-rating></div>
          <div class="col-sm-12">
            <mat-form-field2 class="d-block">
              <input
                matInput
                type="text"
                i18n-placeholder
                placeholder="Public Review"
                [value]="data.review.public_review"
                disabled
              />
            </mat-form-field2>
          </div>
          <div class="col-sm-12">
            <mat-form-field2 class="d-block">
              <input
                matInput
                type="text"
                i18n-placeholder
                placeholder="Private Feedback"
                [value]="data.review.private_feedback"
                disabled
              />
            </mat-form-field2>
          </div>
        </div>
        <div class="row" *ngFor="let item of data.review.category_ratings">
          <div class="col-sm-4">
            <mat-form-field2 class="d-block">
              <input
                matInput
                type="text"
                i18n-placeholder
                placeholder="Category"
                [value]="item.category | titleCase"
                disabled
              />
              <app-rating matSuffix [rating]="item.rating"></app-rating>
            </mat-form-field2>
          </div>
          <div class="col-sm-4">
            <mat-form-field2 class="d-block">
              <input
                matInput
                type="text"
                i18n-placeholder
                placeholder="Comment"
                [value]="item.comment || ''"
                disabled
              />
            </mat-form-field2>
          </div>
        </div>
        <div>
          <mat-form-field2 class="d-block">
            <textarea
              matInput
              i18n-placeholder
              placeholder="Response"
              formControlName="message"
              required
              cdkTextareaAutosize
            ></textarea>
          </mat-form-field2>
        </div>
        <div>
          <span *ngIf="data.review.responded_at">
            <ng-container i18n>Responded:</ng-container> {{ data.review.responded_at | date }} </span
          >&nbsp;
          <span *ngIf="data.review.expires_at">
            <ng-container i18n>Expired:</ng-container> {{ data.review.expires_at | date }}
          </span>
        </div>
      </form>
    </div>
  </div>
</div>
